query MegaMenuModule {
    megaMenuModule {
        categoryId
        id
        keyword
        productCount
        target
        title
        type
        url
        children {
            categoryId
            id
            keyword
            productCount
            target
            title
            type
            url
            children {
                categoryId
                id
                keyword
                productCount
                target
                title
                type
                url
            }
        }
    }
}